module.exports = {"130471001":"开发区街道","130471100":"尚璧镇","130471101":"南沿村镇","130471200":"小西堡乡","130471201":"姚寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130471.json
// module id = 214
// module chunks = 0